<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="fmh">CONTENTS</h1>
<p class="contents" id="ch1"><span class="nl5"> </span><a href="#/9781789742671_EPUB6">General preface</a></p>
<p class="contents" id="ch2"><span class="nl5"> </span><a href="#/9781789742671_EPUB7">Author’s preface</a></p>
<p class="contents" id="ch3"><span class="nl5"> </span><a href="#/9781789742671_EPUB8">Abbreviations</a></p>
<p class="contents" id="ch4"><span class="nl5"> </span><a href="#/9781789742671_EPUB9">Select bibliography</a></p>
<p class="linespace"></p>
<p class="contents" id="ch5"><span class="nl5"> </span><a href="#/9781789742671_EPUB10"><strong class="bold">Introduction</strong></a></p>
<p class="linespace"></p>
<p class="contents" id="ch6"><a href="#/9781789742671_EPUB10#rch1">1.<span class="nl3"> </span>Hermeneutical considerations</a></p>
<p class="contents" id="ch7"><a href="#/9781789742671_EPUB10#rch2">2.<span class="nl3"> </span>Historical matters</a></p>
<p class="contents" id="ch8"><a href="#/9781789742671_EPUB10#rch3">3.<span class="nl3"> </span>Literary matters</a></p>
<p class="contents" id="ch9"><a href="#/9781789742671_EPUB10#rch4">4.<span class="nl3"> </span>Theological messages and themes</a></p>
<p class="linespace"></p>
<p class="contents" id="ch10"><span class="nl5"> </span><span href="#/9781789742671_EPUB11" title="Link target outside of Sample"><strong class="bold1">Analysis</strong></span></p>
<p class="linespace"></p>
<p class="contents" id="ch11"><span class="nl5"> </span><span href="#/9781789742671_EPUB13" title="Link target outside of Sample"><strong class="bold1">Commentary</strong></span></p>
<p class="linespace"></p>
<p class="contents" id="ch12"><span href="#/TOTC_praise" title="Link target outside of Sample">Praise for the Tyndale Commentaries</span></p>
<p class="contents" id="ch13"><span href="#/appen9" title="Link target outside of Sample">About the author</span></p>
<p class="contents" id="ch14"><span href="#/TOTC_commentaries" title="Link target outside of Sample">Tyndale Commentaries from InterVarsity Press</span></p>
<p class="contents" id="ch15"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="contents" id="ch16"><span href="#/IVPtbs" title="Link target outside of Sample">IVP Academic Textbook Selector</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781789742671_EPUB5.vue?13f3b9ca